export default {"src":"/_next/static/media/cicon2.e0c5dffc.svg","height":56,"width":51};